import { render, staticRenderFns } from "./founderStageOneDetails.vue?vue&type=template&id=c8dda426"
import script from "./founderStageOneDetails.vue?vue&type=script&lang=js"
export * from "./founderStageOneDetails.vue?vue&type=script&lang=js"
import style0 from "./founderStageOneDetails.vue?vue&type=style&index=0&id=c8dda426&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports